export default __webpack_public_path__ + "static/media/harry.c1d40fce.png";